import api from "../api";
import ApiConstant from "../../constants/api.constants";

// GET all subscriptions for logged-in user
const getAllUserSubscriptions = async () => {
  try {
    const res: any = await api
      .get(ApiConstant.getAllUserSubscriptions)
      .then((result: any) => (result ? result.data : null))
      .catch((error: any) => {
        console.error("Error fetching user subscriptions", error);
      });
    return res ?? [];
  } catch (e) {
    console.error("Unexpected error fetching subscriptions", e);
    return [];
  }
};

// GET detailed subscription by ID (including products, address, etc.)
const getSubscriptionById = async (subscriptionId: number) => {
  try {
    const res: any = await api
      .get(`${ApiConstant.getAllUserSubscriptions}/${subscriptionId}`)
      .then((result: any) => (result ? result.data : null))
      .catch((error: any) => {
        console.error("Error fetching subscription details", error);
        // For now, return mock data structure until API is available
        return null;
      });
    return res;
  } catch (e) {
    console.error("Unexpected error fetching subscription details", e);
    return null;
  }
};


const createUserSubscription = async (subscriptionData: any) => {
  try {
    const res: any = await api
      .post(ApiConstant.createUserSubscription, subscriptionData)
      .then((result: any) => result?.data)
      .catch((error: any) => {
        console.error("Error creating subscription", error);
        throw error;
      });
    return res;
  } catch (e) {
    console.error("Unexpected error creating subscription", e);
    throw e;
  }
};

// UPDATE subscription
const updateUserSubscription = async (subscriptionData: any) => {
  try {
    const res: any = await api
      .put(ApiConstant.updateUserSubscription, subscriptionData)
      .then((result: any) => (result ? result.data : null))
      .catch((error: any) => {
        console.error("Error updating subscription", error);
      });
    return res ?? null;
  } catch (e) {
    console.error("Unexpected error updating subscription", e);
    return null;
  }
};


const pauseUserSubscription = async (subscriptionId: number) => {
  try {
    const url = ApiConstant.pauseUserSubscription.replace("{id}", subscriptionId.toString());
    console.log("Calling pause API:", url);

    const res = await api.post(url);

    console.log("Pause response:", res);

    // Some APIs return 204 No Content → res.data will be undefined
    return res.data ?? true; // return true if success but no data
  } catch (error: any) {
    console.error("Error pausing subscription", error.response ?? error);
    return null;
  }
};

// RESUME subscription
const resumeUserSubscription = async (subscriptionId: number) => {
  try {
    const url = ApiConstant.resumeUserSubscription.replace("{id}", subscriptionId.toString());
    console.log("Calling Resume API:", url);

    const res = await api.post(url);

    console.log("Resume response:", res);

    // Some APIs return 204 No Content → res.data will be undefined
    return res.data ?? true; // return true if success but no data
  } catch (error: any) {
    console.error("Error pausing subscription", error.response ?? error);
    return null;
  }
};

const UserSubscriptionService = {
  getAllUserSubscriptions,
  getSubscriptionById,
  createUserSubscription,
  updateUserSubscription,
  pauseUserSubscription,
  resumeUserSubscription,
};

export default UserSubscriptionService;
